import React from 'react';

import ExpiringDevicesContainer from './ExpiringDevicesContainer';
import NotificationsContainer from './NotificationsContainer';

class Dashboard extends React.Component {
  render() {
    return (
      <div className="Dashboard">
        <ExpiringDevicesContainer />
        <NotificationsContainer />
      </div>
    )
  }
}

export default Dashboard



// WEBPACK FOOTER //
// ./src/features/dashboard/index.jsx